import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';
import { categories } from '@/mocks/categories';
import TopicCard from '@/components/feature/TopicCard';

function categoryName(slug: string) {
  const found = categories.find((cat) => cat.slug === slug);
  return found ? found.name : '';
}

export default function HotTopics() {
  const list = topics.slice(4, 10);

  return (
    <section className="border-b border-background-200 bg-background-100 py-12 md:py-16" aria-labelledby="hot-heading">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="mb-7 flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-200 px-3 py-1 text-xs text-secondary-900">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-chat-3-line text-sm" />
              </span>
              讨论量领先
            </span>
            <h2 id="hot-heading" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              热议话题
            </h2>
          </div>
          <div className="hidden flex-wrap items-center gap-2 md:flex">
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="cursor-pointer whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((topic) => (
            <TopicCard key={topic.slug} topic={topic} categoryName={categoryName(topic.categorySlug)} />
          ))}
        </div>
      </div>
    </section>
  );
}